import {
    Table,
    Button,
    ButtonGroup,
} from 'react-bootstrap';

export const TradingZonesTable = ({
    tradingZones,
    handleEditZone,
    handleDeleteZone,
}) => {

    return (
        <div>
            {tradingZones && tradingZones.length > 0 &&
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Ticker</th>
                            <th>Type</th>
                            <th>Preset Zone</th>
                            <th>Min</th>
                            <th>Max</th>
                            <th>Time Window</th>
                            <th>Label</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tradingZones.map(zone => {
                            return (
                                <tr key={zone.id}>
                                    <td>{zone.ticker}</td>
                                    <td>{zone.type}</td>
                                    <td>{zone.displayText}</td>
                                    <td>{zone.min}</td>
                                    <td>{zone.max}</td>
                                    <td>{`${zone.startTime.toString()} - ${zone.endTime.toString()}`}</td>
                                    <td>{zone.label}</td>
                                    <td>
                                            <ButtonGroup size="sm">
                                                <Button
                                                    size="sm"
                                                    variant="primary"
                                                    onClick={() => handleEditZone(zone)}>
                                                    Edit
                                                </Button>
                                                <Button
                                                    size="sm"
                                                    variant="secondary"
                                                    onClick={() => handleDeleteZone(zone)}>
                                                    Delete
                                                </Button>
                                            </ButtonGroup>
                                    </td>
                                </tr>
                            );
                        })
                        }
                    </tbody>
                </Table>
            }
        </div>


    )
}